module.exports = __webpack_public_path__ + "img/care_main.275820ee.png";